import axios from 'axios';
import { removeEmptyAndNullValues } from '../../Containers/Helpers/Helpers';
import { Constant } from '../../Containers/Helpers/constant';

export default async function apiCall(config) {
  const isClient =
    (Constant.userTypes.CLIENT === Number(localStorage.getItem('userType')) ||
      !localStorage.getItem('userType') ||
      Constant.userTypes.ADMIN_USER_V2 === Number(localStorage.getItem('userType')) ||
      Constant.userTypes.VENDOR_USER_V2 === Number(localStorage.getItem('userType')) ||
      Constant.userTypes.CLIENT_USER_V2 === Number(localStorage.getItem('userType'))) &&
    (Constant.PROJECT_CODE === 'ADIB_V2' ||
      Constant.PROJECT_CODE === 'ADMIN_ACCESS' ||
      !JSON.parse(window.localStorage.getItem('data'))?.program?.code);

  const headers = { ...config.headers };
  Object.keys(headers).forEach(key => {
    if (headers[key] === undefined || headers[key] === null || headers[key] === '') {
      delete headers[key];
    }
  });

  const response = await axios({
    method: `${config.method}`,
    url: `${config.url}`,
    headers,
    params: config?.params,
    data: config.isFormData ? config.data : JSON.stringify(config.data),
    paramsSerializer: customParamsSerializer,
    withCredentials: isClient,
    responseType: config?.isOctetStream ? 'blob' : 'json',
  })
    .then(function (response) {
      return response;
    })
    .catch(err => {
      return err;
    });
  return response;
}

const customParamsSerializer = params => {
  return Object.entries(removeEmptyAndNullValues(params))
    .map(([key, value]) => {
      if (typeof value === 'object') {
        return `${key}=${encodeURIComponent(JSON.stringify(value))}`;
      }
      return `${key}=${encodeURIComponent(value?.toString() ?? '')}`;
    })
    .join('&');
};
